import { Link } from "react-router-dom";

import { Logo } from "@/components/ui/Logo";

export const Footer = () => (
  <footer className="bg-landing-footer">
    <div className="landing-container-wide flex flex-col justify-between gap-6 py-19 max-md:py-12 sm:flex-row sm:items-center">
      <Link
        to="/"
        aria-label="Spider"
        className="-m-2 self-start sm:self-auto"
      >
        <Logo
          iconClassName="landing-logo text-landing-ink size-7"
          textClassName="text-landing-ink text-[2rem] leading-none"
        />
      </Link>

      <p className="text-[0.75rem] leading-[1.5] font-normal text-[#888888]">
        © {new Date().getFullYear()} Spider Bot. Все права защищены. Разработано с уважением к вашей
        свободной жизни.
      </p>
    </div>
  </footer>
);
